// Deprecated.

import { withMetadata } from '../min/metadata'

import _isPossibleNumber from '../es6/isPossibleNumber'

export function isPossibleNumber() {
	return withMetadata(_isPossibleNumber, arguments)
}



//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/index.es6.exports/isPossibleNumber.js
// module id = 4dPg
// module chunks = 0 1